import React, { ReactNode } from 'react';

const TcButton = ({ 
    children,
    handleClick = () => {}, 
    disabled = false, 
    primary = false, 
    hollow = false, 
    classNameStyle = "", 
    icon = "", 
    hasIcon = icon.length > 0
}: {
    children?: ReactNode;
    handleClick?: () => void;
    disabled?: boolean;
    primary?: boolean;
    hollow?: boolean;
    classNameStyle?: string;
    hasIcon?: boolean;
    icon?: string;
}) => {
    return (
        <button
            onClick={handleClick}
            disabled={disabled}
            className={`
                mx-auto py-3 px-6 min-w-32 w-full font-medium uppercase rounded-xl flex items-center justify-center gap-2 
                ${classNameStyle} 
                ${primary ? 'button-primary' : 'button-normal'} 
                ${hollow ? 'button-hollow' : ''} 
                ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-400 text-gray-500' : ''}
                `}
        >
            {hasIcon && <span>{icon}</span>}
            {children}
        </button>
    )
}

export default TcButton;